import React, { useEffect, useState } from "react";
import { useAppSelector } from "../../../stores/hooks";
import { RootState } from "../../../stores/store";
import BulletImageList from "../../ParticipantsSection/RenderBulletImage";
import { getFacilitator, getParticipants, getRequester } from "../../../functions/FilterUsers";
import "./FeedbackUsersConnectionStatus.scss";
import { t } from "i18next";

const FeedbackUsersConnectionStatus = (): React.JSX.Element => {
  const canvasStore = useAppSelector((state: RootState) => state.canvas);
  const [feedback, setFeedback] = useState<IFeedback>(
    canvasStore.feedback || ({} as IFeedback)
  )

  useEffect(() => {
    setFeedback(canvasStore.feedback || ({} as IFeedback));
  }, [canvasStore])

  return (
    <div className="feedback-bullets">
      {
        feedback.users &&
        <>
          <div className="group">
            <BulletImageList
              title={t('feedbackRoles.requester')}
              userList={[getRequester(feedback.users) as IUser]}
              renderConnectedStatus={true}
            />
          </div>
          <div className="group">
            <span className="separator">|</span>
            <BulletImageList
              title={t('feedbackRoles.facilitator')}
              userList={[getFacilitator(feedback.users) as IUser]}
              renderConnectedStatus={true}
            />
          </div>
          <div className="group">
            <span className="separator">|</span>
            <BulletImageList
              title={t('feedbackRoles.participant')}
              userList={getParticipants(feedback.users)}
              renderConnectedStatus={true}
            />
          </div>
        </>
      }
    </div>
  )
}

export default FeedbackUsersConnectionStatus
